import styled from 'styled-components'

export const StyledNewsCountriesSelect = styled.div``
